import { Inject, Injectable } from '@angular/core';
import { Organization } from '../models/organization.model';
import { AnalyticsYandexMetrikaService } from './analytics-yandex-metrika.service';
import { DOCUMENT } from '@angular/common';
import { Product } from '../models/api.models';
import { OrderResponse } from '../models/api-responses';

export interface AnalyticInterface {
  init(config: any): void;

  productShow(product: Product): boolean;

  orderPlaced(order: OrderResponse): boolean;
}

export interface CustomWindow extends Window {
  yandex_metrika_callbacks2: any[];
  dataLayer: any[];

  [key: string]: any;
}


@Injectable({
  providedIn: 'root',
})
export class AnalyticsService implements AnalyticInterface {

  private analyticService: AnalyticInterface;

  constructor(
    @Inject(Window) private window: CustomWindow,
    @Inject(DOCUMENT) private document: Document
  ) {

  }

  init(organizationInfo: Organization): number | null {

    // тут будет какое-то реальное условие для разделения гугл аналитики и яндекс метрики
    if (organizationInfo.id) {
      this.analyticService = new AnalyticsYandexMetrikaService(
        this.window,
        this.document
      );

      let id: number | string = 87504350; // наш id по-умолчанию
      if (organizationInfo.metadata.yandexMetricId) {
        id = organizationInfo.metadata.yandexMetricId;
      }

      this.analyticService.init({
        id,
        webvisor: true,
        params: [],
        clickmap: true,
        ecommerce: 'dataLayer',
        trackHash: true,
        ut: '',
        trackLinks: true,
        accurateTrackBounce: true,
        triggerEvent: true
      });
      return id;
    } else {
      return null;
    }
  }

  productShow(product: Product): boolean {
    return this.analyticService.productShow(product);
  }

  orderPlaced(order: OrderResponse): boolean {
    return this.analyticService.orderPlaced(order);
  }

}
